import React, { useEffect, useState } from "react";
import SparePartsKeys_ProductListItem from "./SparePartsKeys_ProductListItem.jsx";
import { showAtcModal } from '/Foundation/Common/code/Views/Foundation/Common/AddToCartModalHelper';
import { populateAddToCartModal } from "../SparePartsKeys_Utils.js";
import { setMiniCartTotalQuantity } from "/Foundation/React/code/Utilities/MiniCartHelper";
import {
    fetchDataForAddToCartButtonInBatches,
} from '/Foundation/Common/code/Utils/Extranet/Utils';
import Spinner from "/Foundation/React/code/Components/Extranet/Spinner";
import SparePartAddToCartButton from "./SparePartAddToCartButton.jsx";
import { addCartLines } from "/Foundation/Common/code/Utils/Extranet/Utils";

import {
    LOCAL_STORAGE,
    ROLE_GUIDS
} from '/Foundation/React/code/Utilities/ExtranetConstants';

import { AdobeAnalyticsUtil } from '/Foundation/Common/code/Views/Foundation/Common/AdobeAnalytics/AdobeAnalyticsUtil';
import { Analytics_AddToCart } from '/Foundation/Common/code/Views/Foundation/Common/AdobeAnalytics/Analytics_AddToCart';
import { addToCartByCartLine, addToCartSources } from '/Foundation/CDP/code/Utilities/cdpHelper';

const SparePartsKeys_ProductList = ({ spareParts, translations, servicePartsModalLink, isKeysAndLocks }) => {
    const addToCartModalElement = document.getElementById('addToCartModal');
    const addToCartModalBackdropElement = document.getElementById('addToCartModalBackdrop');
    const [prices, setPrices] = useState(null);
    const isExtranet = _THULEDATA.SitecoreSiteName === "Extranet";
    const user = isExtranet ? JSON.parse(localStorage.getItem(LOCAL_STORAGE.EXTRANET_USER)) : null;
    const [showPrices, setShowPrices] = useState(!isExtranet || (localStorage.getItem('showPrices') === 'true' && user?.HighestRole?.Id !== ROLE_GUIDS.DEALER_HIDE_PRICES));

    const extranetHandler = (() => {
        return {
            getExtranetPrices: () => {
                if (!spareParts || !isExtranet)
                    return;

                setPrices(null);
                let availableProducts = [];
                spareParts.forEach((sparePart) => {
                    availableProducts.push({ itemNumber: sparePart.Id, productType: "Spare part", quantity: 1 });
                });

                fetchDataForAddToCartButtonInBatches(
                    availableProducts,
                    (data) => {
                        setPrices(data);
                    },
                    (error) => {

                    },
                );
            },
            handleTogglePrices: (show) => {
                setShowPrices(show);
            },
            addToCartExtranet: (id, quantity) => {
                let cartIdentifier = localStorage.getItem(LOCAL_STORAGE.CART_IDENTIFIER);
                const product = { cartId: cartIdentifier, productId: id, quantity: quantity };
                addCartLines([product], (data) => {
                }, (error) => { console.log(error) });
            },
            getDeliverydate: (sparePart) => {
                if (isExtranet)
                    return prices ? getItemresponseData(sparePart.Id)?.DeliveryDate : <div></div>;
                return null;
            }
        }
    })()

    useEffect(() => {
        if (isExtranet)
            extranetHandler.getExtranetPrices();
    }, [spareParts]);

    useEffect(() => {
        if (isExtranet) {
            extranetHandler.getExtranetPrices();
            window.addEventListener('toggleShowPrices', (e) => extranetHandler.handleTogglePrices(e.detail));
            return () => {
                window.removeEventListener('toggleShowPrices', extranetHandler.handleTogglePrices);
            };
        }
    }, []);

    const addToCart = (sparePart, quantity) => {
        if (isExtranet) {
            extranetHandler.addToCartExtranet(sparePart.ProductId, quantity);
            return;
        }
        let category = 'accessories';
        if (!quantity)
            quantity = 1;

        if (!sparePart.ProductId) return;

        let products = [{
            productId: sparePart.ProductId,
            category: category,
        }];

        fetch('/api/sitecore/cart/addcartline', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                productsData: products,
                quantity: quantity,
            }),
        })
            .then((response) => response.json())
            .then((data) => {
                if (addToCartModalElement) {
                    showAtcModal(addToCartModalElement, addToCartModalBackdropElement);
                }
                setMiniCartTotalQuantity(data.TotalQuantity);

                const trackingData = Analytics_AddToCart?.GetTrackingDataFromSparePartObject(sparePart);
                if (trackingData) {
                    AdobeAnalyticsUtil.DataLayer.TrackEvent('cart_addition', {
                        add_to_cart_variant: trackingData.source,
                        products: trackingData.products,
                    });
                }
                trackToCDP(data?.Cart, sparePart.ProductId);

            })
            .catch((error) => {
                console.error('Error:', error);
            });

        if (addToCartModalElement) {
            populateAddToCartModal(sparePart);
        }
    };

    const trackToCDP = (cart, productId) => {
        if (typeof addToCartByCartLine === 'undefined' || !cart?.Lines) {
            return;
        }
        addToCartByCartLine(cart, productId, isKeysAndLocks ? addToCartSources.keysAndLocksList : addToCartSources.sparePartsList);
    };

    const getItemresponseData = (id) => {
        return prices?.ItemResponses?.find(x => x.ItemNumber === id);
    }

    const getPriceElement = (sparePart) => {
        if (!showPrices)
            return null;
        if (isExtranet) {
            if (!prices)
                return <div><Spinner /> / {sparePart?.ProductData?.RRPFormatted}</div>
            const itemResponse = getItemresponseData(sparePart.Id);
            return <>{itemResponse?.SalesPrice} / {sparePart?.ProductData?.RRPFormatted}</>
        }
        return sparePart?.PriceFormatted;
    }

    const getAddToCartButton = (sparePart) => {
        if (sparePart.MissingPfasReplacement)
            return <div>{sparePart.PfasErrorMessage}</div>
        return <SparePartAddToCartButton servicePartsModalLink={servicePartsModalLink} translations={translations} itemResponseData={getItemresponseData(sparePart.Id)} prices={prices} addToCart={addToCart} sparePart={sparePart} />;
    }

    return <div className="spm__productList">
        {spareParts && spareParts.length > 0 && <table className="d-none d-lg-table">
            <thead>
                <tr>
                    <th>{translations.Product}</th>
                    <th>{translations.ArticleNumber}</th>
                    <th>{isExtranet ? `${translations.Price}/${translations.RRP}` : translations.Price}</th>
                    {isExtranet && <th>{translations.Availability}</th>}
                    <th><div className="sr-only">Action</div></th>
                </tr>
            </thead>
            <tbody>
                {spareParts.map((sparePart, index) => {
                    const respData = getItemresponseData(sparePart.Id);
                    const notInAssortment = isExtranet && respData?.TranslatedErrorMessage;
                    return <tr key={index}>
                        <td className="heading6"><a target="_blank" href={sparePart.Url}>{(!isKeysAndLocks && sparePart.Badge) && <span>{sparePart.Badge}. </span>}<span className="productName">{sparePart.Name}</span></a></td><td className="paragraph--s">{sparePart.Id}</td>

                        {notInAssortment ? <td>{respData?.TranslatedErrorMessage}</td> :
                            <>
                                <td className="paragraph--s">{getPriceElement(sparePart)}</td>
                                {isExtranet && <td className="paragraph--s"><span className="me-4">{respData?.Availability}</span>{extranetHandler.getDeliverydate(sparePart)}</td>}
                                <td>{getAddToCartButton(sparePart)}</td>
                            </>
                        }
                    </tr>
                })}
            </tbody>
        </table>}

        {spareParts && spareParts.length > 0 && <div className="d-lg-none">
            {spareParts.map((sparePart, index) => {
                const respData = getItemresponseData(sparePart.Id);
                const notInAssortment = isExtranet && respData?.Error;
                return <div key={index}>
                    <SparePartsKeys_ProductListItem isKeysAndLocks={isKeysAndLocks} translations={translations} availability={respData?.Availability} notInAssortment={notInAssortment} deliveryDate={extranetHandler.getDeliverydate(sparePart)} priceElement={getPriceElement(sparePart)} getAddToCartButton={getAddToCartButton} index={index} itemData={getItemresponseData(sparePart.Id)} sparePart={sparePart} />
                </div>
            })}
        </div>}
        {(!spareParts || spareParts.length === 0) && <div className="text-center paragraph">{translations.NoSparepartsAvailable}</div>}
    </div>
}
export default SparePartsKeys_ProductList;